import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import PonudeTable from "Views/Prijevoznici/Ponude/PonudeTable";

const PonudePage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <PonudeTable />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PonudePage;
